// src/services/systemConfig.js

class SystemConfigService  {
  // Generate time slots array based on start and end times
  generateTimeSlots(startTime, endTime) {
    const slots = [];
    let current = startTime;

    while (current <= endTime) {
      slots.push(current);
      
      // Add 30 minutes to current time
      const [hours, minutes] = current.split(':').map(Number);
      const totalMinutes = hours * 60 + minutes + 30;
      const newHours = Math.floor(totalMinutes / 60);
      const newMinutes = totalMinutes % 60;
      
      current = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
      
      // Break if we've passed the end time
      if (current > endTime) break;
    }

    return slots;
  }
}

export const systemConfigService = new SystemConfigService();